function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.3 6.7L3 9V3h6L6.7 5.3l2.89 2.87-1.42 1.42L5.3 6.7zm12-1.4L15 3h6v6l-2.3-2.3-2.87 2.89-1.42-1.42L17.3 5.3zM9 21l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6h6zm9.7-3.7L21 15v6h-6l2.3-2.3-2.89-2.87 1.42-1.42 2.87 2.89z",
  fill: "#666"
})));